import React, { useEffect, useState } from "react";
import { loadImage } from "../../api/medecin";
import { ReactComponent as Close } from "../../assets/icons/icon-close.svg";
import Button from "../ButtonUI";
import Spinner from "../Spinner";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import { getBodyPartLabel } from "../../config/bodyZones";

const formatValue = (value: string | null | undefined) => {
  if (!value || typeof value !== "string") return ""
  return value.replace(/\b\w/g, (char) => char.toUpperCase())
}

interface IProps {
  imageData: object | any;
  closeModal: Function;
  patientId: string;
}

const ImageModal: React.FC<IProps> = ({ imageData, closeModal }) => {
  const { url, type, fileInfo } = imageData;
  const { specialite, patientId, filePath } = fileInfo;

  const [parsedImage, setParsedImage] = useState<string>("");
  const [loader, setLoader] = useState<boolean>(true);


  useEffect(() => {
    setLoader(true);
    loadImage(specialite, patientId, "lossless", filePath).then((res) => {
      setParsedImage(res);
    });
  }, [imageData]);

  const handleFallback = () => {
    loadImage(specialite, patientId, "preview", filePath).then((res) => {
      if (parsedImage !== res) setParsedImage(res);
    });
  };

  return (
    <div className="relative z-60" style={{zIndex: 60}}>
      {parsedImage ? (
        <>
          <div className="absolute top-0 right-0 z-70" style={{zIndex: 70}}>
            <Button status="icon-secondary" onClick={() => closeModal()}>
              <Close />
            </Button>
          </div>
          <div className="row  d-flex justify-content-center py-12 px-20">
            <div className="col-lg-8 text-center text-dark ">
              <TransformWrapper
                doubleClick={{ disabled: false, mode: "zoomIn" }}
              >
                <TransformComponent
                  wrapperStyle={
                    loader
                      ? {
                          background: "#f5f5f9",
                          borderRadius: "10px",
                          cursor: "zoom-in",
                        }
                      : {
                          border: "1px solid gray",
                          background: "#f5f5f9",
                          borderRadius: "10px",
                          cursor: "zoom-in",
                        }
                  }
                >
                  {" "}
                  <div style={{ display: loader ? "block" : "none" }}>
                    <Spinner />
                  </div>
                  <img
                    src={parsedImage}
                    onError={handleFallback}
                    alt="katomi"
                    loading="lazy"
                    className="rounded-lg"
                    onLoad={() => setLoader(false)}
                  />
                </TransformComponent>
              </TransformWrapper>
              <div className="mt-6 text-left border-t border-gray-100 pt-6 space-y-4">
                {/* Ancienneté */}
                <div className="flex items-center gap-3">
                  <span className="text-xs font-bold uppercase tracking-wider text-gray-400 w-28">
                    Ancienneté:
                  </span>
                  <span className="px-3 py-1 bg-blue-50 text-blue-700 rounded-full text-sm font-medium border border-blue-100">
                    {formatValue(fileInfo.anciennete) || "Non spécifié"}
                  </span>
                </div>

                {/* Taille */}
                <div className="flex items-center gap-3">
                  <span className="text-xs font-bold uppercase tracking-wider text-gray-400 w-28">
                    Taille:
                  </span>
                  <span className="px-3 py-1 bg-blue-50 text-blue-700 rounded-full text-sm font-medium border border-blue-100">
                    {fileInfo.taille
                      ? `${formatValue(fileInfo.taille)} mm`
                      : "Non spécifié"}
                  </span>
                </div>

                {/* Douleur */}
                <div className="flex items-center gap-3">
                  <span className="text-xs font-bold uppercase tracking-wider text-gray-400 w-28">
                    Douleur:
                  </span>
                  <span className="px-3 py-1 bg-blue-50 text-blue-700 rounded-full text-sm font-medium border border-blue-100">
                    {formatValue(fileInfo.douleur) || "Non spécifié"}
                  </span>
                </div>

                {/* Body Part */}
                <div className="flex items-center gap-3">
                  <span className="text-xs font-bold uppercase tracking-wider text-gray-400 w-28">
                    Position:
                  </span>
                  <span className="px-3 py-1 bg-blue-50 text-blue-700 rounded-full text-sm font-medium border border-blue-100">
                    {getBodyPartLabel(fileInfo.bodyPart) || "Non spécifié"}
                  </span>
                </div>

                {/* Message Section */}
                <div className="bg-gray-50 rounded-xl p-4 border border-gray-100">
                  <span className="block text-xs font-bold uppercase tracking-wider text-gray-400 mb-2">
                    Message:
                  </span>
                  <p className="text-gray-700 leading-relaxed text-sm whitespace-pre-wrap">
                    {fileInfo.message || "Pas de notes."}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        <>
          <div className="relative w-full  ">
            <Spinner />
          </div>
        </>
      )}
    </div>
  );
};

export default ImageModal;
